
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const TimelinePage = lazy(() => import('../pages/timeline/page'));
const UpdatesPage = lazy(() => import('../pages/updates/page'));
const UpdateDetailPage = lazy(() => import('../pages/updates/detail/page'));
const ChangelogPage = lazy(() => import('../pages/changelog/page'));
const SurveyPage = lazy(() => import('../pages/survey/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/timeline',
    element: <TimelinePage />,
  },
  {
    path: '/updates',
    element: <UpdatesPage />,
  },
  {
    path: '/updates/:id',
    element: <UpdateDetailPage />,
  },
  {
    path: '/changelog',
    element: <ChangelogPage />,
  },
  {
    path: '/survey',
    element: <SurveyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
